
import { RevButtonBase } from '@ds/components/ButtonBase'
import { mapGetters } from 'vuex'

import { COMPANY_NAME } from '@config/constants'
import { ROUTES } from '@router'

import BmLogo from './Logo.svg'

export default {
  components: {
    RevButtonBase,
    BmLogo,
  },
  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),
    COMPANY_NAME: () => COMPANY_NAME,
    ROUTES: () => ROUTES,

    isRebrandingExperimentActive() {
      return this.experiments.headerSoftRebranding === 'white'
    },

    logoClassNames() {
      return [
        {
          'fill-white': !this.isRebrandingExperimentActive,
          'fill-back': this.isRebrandingExperimentActive,
        },
      ]
    },
  },
}
